// The setup of a match: the caster select is open. That is a new match against
// the AI, or a room whose seats pick. While it is open, the board is covered
// and the match on it waits, see `boardCover.ts`. Garrett, 2026-10-14: "have a
// good zone for gamesetting versus game plauing so events aren playing
// simultaneoulsy". This file has no import from the game, so the director can
// read it.

import { createStore } from '../lib/store';
import { type RoomState, roomStore } from './roomStore';

/** True while the caster select is open for a match against the AI. */
export const casterSelectStore = createStore<boolean>(false);

/** A room whose seats pick: the select is its screen. */
export const isRoomPicking = (room: RoomState | null): boolean =>
  room !== null &&
  (room.status === 'connecting' || room.status === 'open' || room.status === 'reconnecting') &&
  (room.view === null || room.view.phase === 'lobby');

/** The select is open for a room whose seats pick, or for a new match against the AI. */
export const isSettingUp = (): boolean => {
  const room = roomStore.get();
  return room ? isRoomPicking(room) : casterSelectStore.get();
};

export const subscribeSetup = (listener: () => void): void => {
  casterSelectStore.subscribe(listener);
  roomStore.subscribe(listener);
};
